import { createSelector } from '@reduxjs/toolkit';
import { selectDevice } from 'entities/device/lib';
export const getConnectionConfig = createSelector((state, device_id) => selectDevice(state, device_id), (dev) => (dev != null ? dev.connection_config : null));
